import React from 'react';
import { useFormContext } from '../../../providers';

export const SocialMediaForm = () => {

  const {
    register,
    errors,
  } = useFormContext();


  return (
    <div className="max-w-4xl p-6 mx-auto bg-white rounded-lg shadow-md">
      <div style={{ display: 'flex', justifyContent: 'center' }} className="dashboard-title">
        <h3>Social Media</h3>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {['facebook', 'instagram', 'airbnb', 'vrbo', 'youtube', 'twitter', 'linkedin', 'pinterest', 'vimeo', 'tripadvisor'].map((platform, idx) => {
          // Customize labels for specific platforms
          let label = platform.charAt(0).toUpperCase() + platform.slice(1); // Default label
          if (platform === 'twitter') {
            label = 'Twitter (X)'; // Add (X) to Twitter label
          } else if (platform === 'youtube') {
            label = 'YouTube'; // Use "YouTube" instead of "Youtube"
          } else if (platform === 'linkedin') {
            label = 'LinkedIn'; // Use "LinkedIn" instead of "Linkedin"
          }

          return (
            <div key={idx} style={{ marginTop: '12px' }}>
              <label className="block text-sm font-medium">
                {`${label} URL`} {/* Use the customized label */}
                <i className={`icon-${platform}`} style={{ position: 'absolute', top: '40px', left: '14px', fontSize: '14px' }} />
              </label>
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                placeholder={`${label} URL`}
                {...register(`${platform}_url`)}
              />
              {errors[`${platform}_url`] && (
                <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">
                  {errors[`${platform}_url`]?.message}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
